import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import "./Auth.css";

function Login() {
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [error, setError] = useState("");
	const [loading, setLoading] = useState(false);
	const { login } = useAuth();
	const navigate = useNavigate();

	async function handleSubmit(e) {
		e.preventDefault();

		try {
			setError("");
			setLoading(true);
			await login(email, password);
			navigate("/");
		} catch (error) {
			setError("Failed to sign in: " + error.message);
		}
		setLoading(false);
	}

	return (
		<div className="main-container">
			<div className="video-background">
				<video autoPlay loop muted playsInline>
					<source src="/images/49a01d274a.mp4" type="video/mp4" />
				</video>
			</div>

			<div className="auth-container">
				<h1>Welcome Back</h1>
				{error && <div className="error">{error}</div>}
				<form onSubmit={handleSubmit} className="auth-form">
					<input
						type="email"
						placeholder="Email"
						value={email}
						onChange={(e) => setEmail(e.target.value)}
					/>
					<input
						type="password"
						placeholder="Password"
						value={password}
						onChange={(e) => setPassword(e.target.value)}
					/>
					<button disabled={loading} type="submit">
						Login
					</button>
					<div className="forgot-password">
						<Link to="/reset-password">Forgot Password?</Link>
					</div>
				</form>
				<div className="auth-switch">
					Need to register? <Link to="/signup">Sign up</Link>
				</div>
			</div>
		</div>
	);
}

export default Login;
